import AlertWarning from "components/Alerts/AlertWarning"
import React from "react"
import {VehicleExtra} from "../../../../../domain-models"

type VehicleConditionProps = {
  condition: string
  extra: VehicleExtra
}

class Condition extends React.Component<VehicleConditionProps> {
  render() {
    const extra = this.props.extra
    return (
      <div className="mt-4 md:mt-0">
        <AlertWarning>
          <p>{this.props.condition}</p>
          <p>{extra?.KnownLacks}</p>
          <p>{extra?.DamageDesc}</p>
          <p>{extra?.DamageDescDetails}</p>
          <p>{extra?.DamageDescOther}</p>
        </AlertWarning>
      </div>
    )
  }
}

export default Condition
